import {ROOT_URL} from "../../config";
import request from "../../components/api/api";
import {toastr} from 'react-redux-toastr';
import {
    fetchedRoles,
    fetchedPermissions,
    fetchedPermissionsGroups,
    fetchedRolesPermissions,
    updatedRolesPermissions
} from "./actions";

export function fetchRoles() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/roles`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedRoles(response.data)));
    };
}

export function fetchPermissions() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/permissions-grouped`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedPermissions(response.data)));
    };
}

export function fetchPermissionsGroups() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/permissions-grouped`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedPermissionsGroups(response.data)));
    };
}


export function fetchRolesPermissions() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/roles?_embed=permissions&_idsonly=true`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedRolesPermissions(response.data)));
    };
}


export function updateRolesPermissions(rolesPermissions) {
    return (dispatch) => {

        let rolesPermissionsToUpdate = {};

        rolesPermissions.forEach((permissions, roleId) => {
            let perms = [];
            Object.keys(permissions).forEach((permissionId) => {
                if (permissions[permissionId]) {
                    perms.push(permissionId);
                }
            });
            rolesPermissionsToUpdate[roleId] = perms;
        });

        let options = {
            url: `${ROOT_URL}/roles-permissions`,
            method: 'PUT',
            data: rolesPermissionsToUpdate
        };
        
        return request(options, dispatch)
            .then(response => dispatch(updatedRolesPermissions(response.data)))
            .then(() => toastr.success('Success!', 'Roles permissions have been updated.'))
    };
}



// WEBPACK FOOTER //
// ./src/containers/roles/thunks.js